"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _layouts = require("@indigenux/design/layouts");
var _components = require("@indigenux/design/components");
var _formik = require("formik");
var _yup = require("yup");
var _notistack = require("notistack");
var _jsxRuntime = require("react/jsx-runtime");
const DataRequest = () => {
  const telephone = "1-513-278-3575";
  const telephoneReference = "tel:" + telephone;
  const mailTo = "privacy@indigenux.com";
  const mailToReference = "mailto:" + mailTo;
  const initialValues = {
    name: "",
    email: "",
    subject: "DR: Request data to be removed",
    message: "Please remove my data from your servers."
  };
  const schema = (0, _yup.object)().shape({
    name: (0, _yup.string)().required("Please enter your name.").max(100),
    email: (0, _yup.string)().required("Please enter your email.").email("Must be a valid email").max(100),
    subject: (0, _yup.string)().required("Please enter the subject.").max(100),
    message: (0, _yup.string)().required("please enter your message.").max(5000)
  });
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const handleSubmit = values => {
    //Send values to API: indigenux.app/data
    console.log("Sending the following information: ", values);
    enqueueSnackbar("Success!  Your message has been sent to us.");
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layouts.Main, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PageHeader, {
      Category: "Legal",
      children: "Data Request"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "row py-4",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "col-lg-6",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Heading, {
            level: "h2",
            children: "Contact Us"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "mb-4",
            children: "Submit a request to have your data removed from our servers."
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Formik, {
            initialValues: initialValues,
            validationSchema: schema,
            onSubmit: handleSubmit,
            validate: values => {},
            children: formik => {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_formik.Form, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "row",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "form-group col-lg-6",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Input, {
                      text: "Full Name",
                      value: formik.values.name,
                      onChange: formik.handleChange,
                      required: true,
                      maxLength: "100",
                      name: "name"
                    })
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "form-group col-lg-6",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Input, {
                      text: "Email Address",
                      value: formik.values.email,
                      onChange: formik.handleChange,
                      required: true,
                      maxLength: "100",
                      name: "email"
                    })
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "row",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "form-group col",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Input, {
                      text: "Subject",
                      value: formik.values.subject,
                      onChange: formik.handleChange,
                      required: true,
                      maxLength: "100",
                      name: "subject",
                      disabled: true
                    })
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "row",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "form-group col",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TextArea, {
                      maxLength: "5000",
                      value: formik.values.message,
                      onChange: formik.handleChange,
                      text: "Additional Information",
                      name: "message",
                      required: true
                    })
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "row",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: "form-group col",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                      type: "submit",
                      value: "Send Message",
                      className: "btn btn-primary btn-modern",
                      "data-loading-text": "Loading..."
                    })
                  })
                })]
              });
            }
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "col-lg-6",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            "data-appear-animation": "fadeIn",
            "data-appear-animation-delay": "800",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Heading, {
              level: "h4",
              children: ["Our ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                children: "Office"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
              className: "list list-icons mt-2",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                  className: "fas fa-map-marker-alt top-6"
                }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                  className: "text-dark",
                  children: "Address:"
                }), " 4120 Conflans Rd, Irving, TX 75061"]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                  className: "fas fa-phone top-6"
                }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                  className: "text-dark",
                  children: "Phone:"
                }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                  href: telephoneReference,
                  children: telephone
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                  className: "fas fa-envelope top-6"
                }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                  className: "text-dark",
                  children: "Email:"
                }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                  href: mailToReference,
                  children: mailTo
                })]
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "pt-5 pb-5",
            "data-appear-animation": "fadeIn",
            "data-appear-animation-delay": "950",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Heading, {
              level: "h4",
              children: ["Business ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                children: "Hours"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
              className: "list list-icons mt-2",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                  className: "far fa-clock top-6"
                }), " Monday - Friday - 9am to 5pm"]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                  className: "far fa-clock top-6"
                }), " Saturday - 9am to 2pm"]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                  className: "far fa-clock top-6"
                }), " Sunday - Closed"]
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Heading, {
            level: "h4",
            children: ["Get in ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
              children: "Touch"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            className: "lead mb-0 text-4",
            children: ["The ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
              href: "/privacy",
              children: "Privacy notice"
            }), " for Indigenux, LLC (\"we,\" \"us,\" or \"our\"), describes how and why we might collect, store, use, and/or share ( \"process\" ) your information when you use our services (\"Services\")."]
          })]
        })]
      })
    })]
  });
};
var _default = exports.default = DataRequest;